import Chip from "@mui/material/Chip";
import {DataTableCellProps} from "@variocube/app-ui";
import {createElement} from "react";
import {AppAuditLogEntry} from "@variocube/app-ui/src/audit/types";

export function AuditTypeChip({row}: DataTableCellProps<AppAuditLogEntry>) {
	return <Chip variant="outlined" label={<code>{row.type}</code>} />;
}
